import { combineReducers } from 'redux';

import type { DiscoverState } from './discover.model';
import { dicoverPageReducer } from './page/page.reducer';

export const discoverReducer = combineReducers<DiscoverState>({
  page: dicoverPageReducer,
});
